import { fetchGet, fetchPost, rootApi } from '../helpers/api';

const healthApi = `${rootApi}/health-data`;

export const fetchErrorType = () => fetchGet("/station-errors.json");

export const fetchLatestHealthData = (stationIds, year) => fetchGet(`${healthApi}/latest/${stationIds}/${year}`);

export const fetchLatestPRData = payload => fetchPost(`${healthApi}/latestPR`, payload);